import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowUpRight } from "lucide-react";
import { Locale } from "@/i18n";
import { localePath } from "@/lib/nav";
import { usePartnerModal } from "@/context/PartnerModalContext";
const interiorImage = "https://media.lacontessina.com/site/src/assets/interior-design-layout.webp";
export default function InteriorDesign() {
  const { t, i18n } = useTranslation();
  const locale = (i18n.language as Locale) || "it";
  const partner = usePartnerModal();

  const stats = [
    { value: "25+", label: t("interior.stats.years") },
    { value: "100%", label: t("interior.stats.made_in_italy") },
    { value: "40+", label: t("interior.stats.countries") },
  ];

  return (
    <section id="interior-design" className="py-24 lg:py-36 bg-background">
      <div className="lc-container-ext grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <img
            src={interiorImage}
            alt={t("home.section.custom_design.image_alt")}
            className="w-full h-auto"
          />

          <div className="grid grid-cols-3 gap-4 mt-6">
            {stats.map((s) => (
              <div key={s.label} className="rounded-[20px] bg-[hsl(var(--surface))] px-5 py-6">
                <div className="font-display text-[36px] md:text-[44px] leading-none tracking-[-0.04em] text-foreground">
                  {s.value}
                </div>
                <div className="mt-2 text-[12px] tracking-[0.18em] uppercase text-foreground/55">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5 order-1 lg:order-2">
          <span className="lc-eyebrow">Interior Design</span>
          <h2 className="mt-6 font-display font-light tracking-[-0.035em] leading-[1.02] text-foreground text-[40px] md:text-[56px] lg:text-[68px]">
            {t("home.section.custom_design.title").split(" ").slice(0, 2).join(" ")}
            <span className="block italic font-serif font-normal">
              {t("home.section.custom_design.title").split(" ").slice(2).join(" ")}
            </span>
          </h2>

          <div
            className="lc-prose mt-8 text-[15px] leading-[28px] text-foreground/65 max-w-[460px]"
            dangerouslySetInnerHTML={{ __html: t("home.section.custom_design.description_html") }}
          />

          <div className="mt-10 flex flex-wrap gap-3">
            <Link to={localePath(locale, "contact")} className="lc-btn-solid">
              {t("button.contact_us")}
              <ArrowUpRight className="h-4 w-4" />
            </Link>
            <button type="button" onClick={partner.open} className="lc-btn-outline">
              {t("button.become_partner")}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
